<template>
  <li
    :data-filter="filter"
    class="wow fadeInUp"
    :class="{ current: currentTab.selected }"
    data-wow-duration="0.8s"
    data-wow-delay="0.2s"
    @click="switchTab"
  >
    <slot></slot>
  </li>
</template>

<script>
export default {
  data() {
    return {
      currentTab: {},
    };
  },

  props: {
    name: {
      required: true,
      type: String,
    },

    filter: {
      required: true,
      type: String,
    },
  },

  watch: {
    "$parent.tabs"() {
      this.currentTab = this.$parent.tabs.find((tab) =>
        tab.name.includes(this.name)
      );
    },
  },

  methods: {
    switchTab(event) {
      this.$parent.tabs.forEach((tab) => {
        // Set all $parent.tabs selected prop to false
        // Filter $parent.tabs & check if tab-name == [prop] this.name
        if (tab.name.includes(this.name)) tab.selected = true;
        else tab.selected = false;
      });

      // $(event.target.parentElement).addClass("something-nice")
      //   portfolio-nav

      //   console.log("Next is event.target");
      //   console.log(
      //     $(`.${event.target.parentElement.className.split(" ").join(".")}`)
      //   );

      //   $("#filter-button > ul > li").click(function () {
      //     // console.log($(this));
      // //   console.log("==================jbkjjuihu======================");
      // 	console.log($(event.target.parentNode))
      //   });

    //   var selector = $(event.target.parentNode).attr("data-filter");
    //   window.myContainer.isotope({
    //     filter: selector,
    //     animationOptions: {
    //       queue: true,
    //     },
    //   });
    },
  },

  mounted() {
    // if (this.currentTab == {})
    this.currentTab = this.$parent.tabs.find((tab) =>
      tab.name.includes(this.name)
    );
  },
};
</script>
